import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { map, isEmpty } from 'lodash';

import { updateProfile,
         updateOnboardingStatus,
         onProfileChange,
         onProfileUnsaved,
         initializeProfile } from '../actions/profile';

import Button from 'patternity/lib/button2';
import Alert from 'patternity/lib/alert';
import { withNamespaces } from 'react-i18next';

import ProfileForm from '../components/profile_form';

class Profile extends Component {
  static propTypes = {
    onCloseDialog: PropTypes.func.isRequired,
    contact: PropTypes.object.isRequired,
    csrfToken: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    continueStatus: PropTypes.string.isRequired,
    error: PropTypes.object.isRequired,
    analytics: PropTypes.object.isRequired,
    supportedLanguages: PropTypes.array
  }

  componentDidMount = () => {
    this.props.dispatch(initializeProfile(this.props.contact));
    window.pageEventsTracker.startActivity({ category: 'Standard Onboarding', name: 'Fill Out Your Profile' });
  }

  componentWillUnmount = () => {
    window.pageEventsTracker.stopActivity({ category: 'Standard Onboarding', name: 'Fill Out Your Profile' });
  }

  render() {
    this._wasProfileDataSaved();

    return (
      <section>
        <h2 className="knowYouBetter" style={styles.title}>{this.props.t('Help us get to know you better')}</h2>

        {this._renderErrors()}

        {this._renderProfileForm()}


      </section>
    );
  }

  _wasProfileDataSaved = () => {
    if (this.props.continueStatus === 'saved') {
      this.props.analytics.logEvent("Onboarding - New Profile Submit");
      setTimeout(() => {
        if (window.parent.location.href === window.location.href) {
          window.location.reload();
        } else {
          if (this.props.profileUpdated) {
            window.parent.location.reload();
          } else {
            window.parent.postMessage("hide_onboarding_modal", '*');
          }
        }
      }, 800);
    }
  }

  _renderProfileForm = () => {
    return (
      <ProfileForm
        onProfileChange={this._handleProfileChange}
        profile={this.props.profile}
        continueStatus={this.props.continueStatus}
        onUpdateHandler={this._onUpdateHandler}
        onCloseDialog={this._handleCloseDialog}
        supportedLanguages={this.props.supportedLanguages}
        errors={this._profileErrors()} />
    );
  }

  _profileErrors = () => {
    if(isEmpty(this.props.error.errors)) return {};

    return this.props.error.errors;
  }

  _handleProfileChange = (event) => {
    this.props.dispatch(onProfileChange(event.target.name, event.target.value));
  }

  _onUpdateHandler = () => {
    window.pageEventsTracker.trackClick({ elementName: 'Update Profile', category: 'Standard Onboarding', pageName: 'Fill Out Your Profile' });
    this.props.dispatch(updateProfile(this.props.csrfToken, this.props.contact));
  }

  _handleCloseDialog = (event) => {
    window.pageEventsTracker.trackClick({ elementName: 'Skip for now', category: 'Standard Onboarding', pageName: 'Fill Out Your Profile' });
    this.props.analytics.logEvent("Onboarding - New Profile Skip");
    this.props.dispatch(updateOnboardingStatus(this.props.csrfToken, this.props.contact));
    this.props.onCloseDialog(event);
  }

  _renderErrors = () => {
    if (isEmpty(this.props.error)) return null;
    const fullMessages = this.props.error.errors._full_messages

    return (
      <div style={styles.alertMsg}>
        <Alert title="Profile Error" type='error' showIcon={true}>
          <ul style={styles.errorList}>
            {this._parsingErrors(fullMessages)}
          </ul>
        </Alert>
      </div>
    );
  }

  _parsingErrors = (fullMessages) => {
    return map(fullMessages, (message) => {
      return (
        <li> {message} </li>
      )
    });
  }

  _errors = () => {
    return map(this.props.errors.errors, function(error, field) {
      return (
        <p>{field} - {error}</p>
      );
    });
  }
}

const styles = {
  title: {
    fontSize: '38px',
    marginBottom: '10px',
    textAlign: 'center',
    lineHeight: '40px'
  },
  profileActions: {
    textAlign: 'center',
    margin: '10px'
  },
  description: {
    textAlign: 'center',
    padding: '20px 20px 0px'
  },
  alertMsg: {
    width: '80%',
    overflow: 'hidden',
    margin: '20px auto',
  },
  errorList: {
    listStyleType: "disc"
  }
};

export default connect(function(state) {
  return state.profile;
})(withNamespaces()(Profile));



// WEBPACK FOOTER //
// ./src/advocate/onboarding/containers/profile.js